module.exports = __webpack_public_path__ + "media/images/but-search-lrg-d05731c9.png";